<template>
  <!--Row Title-->
  <div class="px-4 py-3 flex">
    <font-awesome-icon class="text-lg text-bluegray-600 mr-2" :icon="row.icon" />
    <span>{{ row.rowTitle }}</span>
  </div>
  <!--Pros-->
  <div class="px-4 py-3 border-l border-gray-300 flex items-start gap-2">
    <ResizableTextArea :name="id" class="h-full nomargin"
      :class="{ 'border rounded': !readOnly, 'border-none': readOnly }" :placeholder="prosValue" :readOnly="readOnly"
      v-on:change="save" v-model="prosValue" :inTable="true" />
  </div>
  <!--Cons-->
  <div class="px-4 py-3 border-l border-gray-300 flex items-start gap-2">
    <ResizableTextArea :name="id" class="h-full nomargin"
      :class="{ 'border rounded': !readOnly, 'border-none': readOnly }" :placeholder="consValue" :readOnly="readOnly"
      v-on:change="save" v-model="consValue" :inTable="true" />
  </div>
  <!-- End Input row -->
</template>

<script>
import ResizableTextArea from '@/views/components/textarea/ResizableTextArea.vue';

export default {
  props: {
    row: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    ResizableTextArea,
  },
  data() {
    return {
      id: this.$uuid(),
      prosValue: this.row && this.row.pros ? this.row.pros : '',
      consValue: this.row && this.row.cons ? this.row.cons : '',
    };
  },
  methods: {
    save() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.row.id, prosValue: this.prosValue, consValue: this.consValue, pageId: this.pageId,
        }),
      };
      this.isSaving = true;
      const self = this;
      fetch(`${window.location.origin}/api/schema/SaveProsConsRow`, requestOptions)
        .then(() => {
          this.$emit('onSave');
          this.$emit('getSchema');
        }).then(() => {
          self.isSaving = false;
          this.$toast.open({
            message: 'Lagret',
            type: 'success',
            dismissible: true,
          });
        });
    },
  },
  computed: {
    formattedPros() {
      if (this.prosValue) return this.prosValue.replace(/\n/g, '<br>');
      return '';
    },
    formattedCons() {
      if (this.consValue) return this.consValue.replace(/\n/g, '<br>');
      return '';
    },
  },
  emits: ['onSave', 'getSchema'],
};
</script>
